// Types
import { GetActionEventsResponse } from 'app/modules/actionEvents/responses';
import { RtrDecision, RuleStatuses } from 'app/modules/rules/models';

export enum EventActionTypes {
  EDIT_EVENT = '@@events/EDIT_EVENT',
  EDIT_EVENT_SUCCESS = '@@events/EDIT_EVENT_SUCCESS',

  RETRIEVE_ACTION_EVENTS = '@@events/RETRIEVE_ACTION_EVENTS',
  RETRIEVE_ACTION_EVENTS_SUCCESS = '@@events/RETRIEVE_ACTION_EVENTS_SUCCESS',
}

export interface EventEditRequest {
  eventId: string;
  tags?: (string | number)[];
  comment?: string;
}

export interface EventState {
  actionEvents: GetActionEventsResponse;
}

export enum EvaluationLogStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  ERROR = 'ERROR',
}

export interface EvaluationLogFlow {
  id: number;
  name: string;
  decision: RtrDecision;
  alert_generated: boolean;
  decision_source?: {
    node_id: number;
    node_name: string;
  };
}

export interface EvaluationLog {
  evaluation_id: string;
  event_id: string; // external id of client
  flow?: EvaluationLogFlow;
  rule_executions: {
    [rule_id: string]: {
      rule_name: string;
      status: EvaluationLogStatus;
    };
  };
}

export interface ShadowEvaluationLog {
  evaluation_id: string;
  event_id: string; // external event id
  rule_executions: {
    [rule_id: string]: {
      rule_name: string;
      status: EvaluationLogStatus;
      rule_status: RuleStatuses;
    };
  };
}
